import { SCORM } from "pipwerks-scorm-api-wrapper";

const Scorm = {
    init() {
        SCORM.init();
    },

    getLMSData() {
        const lmsData = {
            student_id: SCORM.get("cmi.core.student_id"),
            student_name: SCORM.get("cmi.core.student_name"),
            lesson_location: SCORM.get("cmi.core.lesson_location"),
            credit: SCORM.get("cmi.core.credit"),
            lesson_status: SCORM.get("cmi.core.lesson_status"),
            entry: SCORM.get("cmi.core.entry"),
            score: {
                raw: SCORM.get("cmi.core.score.raw"),
                min: SCORM.get("cmi.core.score.min"),
                max: SCORM.get("cmi.core.score.max"),
            },
            total_time: SCORM.get("cmi.core.total_time"),
            lesson_mode: SCORM.get("cmi.core.lesson_mode"),
            launch_data: SCORM.get("cmi.core.launch_data"),
        };
        return lmsData;
    },

    submitMCQ(correct, response) {
        let nextIndex = SCORM.get("cmi.interactions._count", true);
        SCORM.set(
            "cmi.interactions." + nextIndex + ".id",
            "round_" + nextIndex
        );
        SCORM.set("cmi.interactions." + nextIndex + ".type", "choice");
        SCORM.set(
            "cmi.interactions." + nextIndex + ".student_response",
            response
        );
        SCORM.set("cmi.interactions." + nextIndex + ".result", correct);
    },

    finish() {
        console.log("you have finished!");
        SCORM.set("cmi.core.lesson_status", "completed");
        SCORM.save();
    },
};

export default Scorm;
